export enum MerchantTgGroupRole {
  DISPUTE_CREATION = 'DISPUTE_CREATION',
  RECEIPT_FORWARD = 'RECEIPT_FORWARD',
}
